export const AUTH_PARAMS = 'auth-polis-params';
export const USER_INFO = 'auth-user-info';
export const AUTH_DAC = 'auth-user-dac';
